export enum InteractionName {
  ALE_LOADER = 'load-phase-loader',
  ALE_RENDER = 'load-phase-render',
  PAYMENTS_WIDGET_LOAD = 'payments-widget-load',
}

export enum PayButtonInteractionName {
  PAYMENTS_APP_IS_OPENED = 'pay-button-open-payments-app',
}
